import React, { useState } from 'react';
import { prop } from 'ramda';

import { ContactInfoUpdateForm } from './components/ContactInfoUpdateForm';

import { Button } from 'js/components/common/Button';

import { clsx } from 'js/app/utils/clsx.util';
import { useTranslations } from 'js/hooks/i18n';
import { useUserSelector } from 'js/store/hooks';

import style from './ContactInfoUpdate.scss';

export const ContactInfoUpdate = ({ closePopup, terms }) => {
    const [isShowForm, setIsShowForm] = useState(false);
    const t = useTranslations('playtech.mobile.system.enter-draw.contact-popup.');
    const {
        firstName = '',
        lastName = '',
        address = '',
        city = '',
        state,
        zip,
        phone,
        cellphone = phone,
        email = ''
    } = useUserSelector(prop('userDetails'));

    return (
        <>
            {isShowForm
                ? (
                    <div className={style.block}>
                        <ContactInfoUpdateForm
                            closePopup={closePopup}
                            closeForm={() => setIsShowForm(false)}
                        />
                    </div>
                )
                : (
                    <div className={style.block}>
                        <div className={style.summary}>
                            <div className={clsx(style.summaryRow, style.name)}>
                                {`${firstName} ${lastName}`}
                            </div>

                            <div className={clsx(style.summaryRow, style.summaryRowAddress)}>
                                <span>{address},</span>

                                {state && <span>{state},</span>}

                                <span>{city},</span>

                                <span>{zip}</span>
                            </div>

                            <div className={style.summaryRow}>
                                {cellphone}
                            </div>

                            <div className={style.summaryRow}>
                                {email}
                            </div>
                        </div>

                        <div className={style.summaryButtons}>
                            <Button
                                size="small"
                                data-testid="ContactInfoUpdate__close"
                                className={clsx(style.button, style.buttonYes)}
                                onClick={closePopup}
                            >
                                {t('button.yes')}
                            </Button>

                            <Button
                                view="link"
                                size="small"
                                className={style.button}
                                data-testid="ContactInfoUpdate__showForm"
                                onClick={() => setIsShowForm(true)}
                            >
                                {t('button.no')}
                            </Button>
                        </div>

                        {terms && (
                            <span
                                data-testid="ContactInfoUpdate__terms"
                                className={style.terms}
                            >
                                {terms}
                            </span>
                        )}
                    </div>
                )
            }
        </>
    );
};
